/**
 * The loader script injects this app inside an <iframe> pointed at
 * .../embed?key=kwg_xxx - the seller's ChannelConnection.publicKey. This is
 * the only identifier the widget ever has; it never knows the seller's
 * internal organizationId directly (the backend resolves that server-side
 * from the key).
 */
export function getWidgetKey(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get("key");
}

/**
 * The short-lived session token the loader script (public/widget.js) minted
 * server-side and forwarded into this iframe's URL - see api-client.ts,
 * which sends it on every request instead of relying on Origin/Referer
 * (meaningless here, since every embed's iframe shares this same origin).
 */
export function getWidgetToken(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get("token");
}

const VISITOR_ID_STORAGE_KEY = "koomarce_widget_visitor_id";

/**
 * A persistent per-browser visitor id, used as `externalCustomerId` when
 * calling the cart/order/conversation endpoints - those are all scoped by
 * (organizationId, channel, externalCustomerId), same identity a WhatsApp
 * phone number or Telegram chat id would use for those same endpoints.
 */
export function getOrCreateVisitorId(): string {
  const existing = window.localStorage.getItem(VISITOR_ID_STORAGE_KEY);
  if (existing) return existing;

  const generated =
    typeof crypto !== "undefined" && "randomUUID" in crypto
      ? crypto.randomUUID()
      : `visitor-${Date.now()}-${Math.random().toString(16).slice(2)}`;

  window.localStorage.setItem(VISITOR_ID_STORAGE_KEY, generated);
  return generated;
}
